export const QUERY_KEYS = {
  CALL_TRANSCRIPTS: "callTranscripts",
  FAVORITES: "favorites",
  ADDRESS_DATA_BY_ID: "addressDataById",
  ADDRESS_LIST: "addressList",
  ADDRESS_NOTES: "addressNotes",
  ADDRESS_CHANGE_LOG: "addressChangeLog",
  ASSOCIATED_ACCOUNTS: "associatedAccounts",
  NEARBY_DETAILS: "nearbyDetails",
  VERIFIED_DETAILS: "verifiedDetails",
  ADDRESS_COUNTS: "addressCounts",
  UPCOMING_DETAILS: "upcomingDetails",
  TERMINAL_NAME: "terminalName",
  TERMINAL_DELETION_REQUEST: "terminalDeletionRequest",
  NOTIFICATIONS: "notifications",
  EMPLOYEE_NOTIFICATION_PREFERENCES: "employeeNotificationPreferences",
  DRIVER_LIST: "driverList",
  DRIVER_DETAILS: "driverDetails",
  EDIT_DRIVER: "editDriver",
  ZIPCODE_LOCATIONS: "zipcodeLocations",
  TIMEZONE: "timezone",
  PICKUP_SUMMARY: "pickupSummary",
  INBOUND_FREIGHT_SUMMARY: "inboundFreightSummary",
  INHOUSE_SUMMARY: "inhouseSummary",
  INBOUND_FREIGHT_BY_TERMINAL: "inboundFreightByTerminal",
  INBOUND_FREIGHT_COUNTS: "inboundFreightCounts",
  AVAILABLE_DOORS: "availableDoors",
  INHOUSE_FREIGHT_BY_ETA: "inhouseFreightByETA",
  OUTBOUND_PLANNING:"outboundPlanning",
  GET_MAKES: "GET_MAKES",
  GET_LEASE_TYPES: "GET_LEASE_TYPES",
  GET_ASSET_DESCRIPTOR: "GET_ASSET_DESCRIPTOR",
  GET_EQUIPMENT_TYPES: "GET_EQUIPMENT_TYPES",
  GET_EQUIPMENT_LIST: "GET_EQUIPMENT_LIST",
  GET_TERMINALS_LIST: "GET_TERMINALS_LIST",
  GET_PRODUCT_LINES: "GET_PRODUCT_LINES",
  GET_EQUIPMENT_DETAIL: "GET_EQUIPMENT_DETAIL",
  GET_DISPATCH_BOARD_QUEUE: "GET_DISPATCH_BOARD_QUEUE",
  GET_DISPATCH_BOARD_QUEUE_LOAD: "GET_DISPATCH_BOARD_QUEUE_LOAD",
  GET_DISPATCH_BOARD_QUEUE_LOAD_DETAILS: "GET_DISPATCH_BOARD_QUEUE_LOAD_DETAILS",
  GET_DISPATCH_BOARD_DOORS: "GET_DISPATCH_BOARD_DOORS"
};
